module.exports = __webpack_public_path__ + "img/icon-resend-invitation.2de87b40.svg";